import { RouteObject } from "react-router-dom";
import { PermissionEnum } from "@rms-types/modules/permission/enum";

import { RouteElement } from "../components/RouteElement";
import { AppRoute } from "../types";

interface GetRouteChildrenArgs {
  routes: AppRoute[];
  parentPermissions?: PermissionEnum[];
}

export function getRouteChildren({ routes, parentPermissions }: GetRouteChildrenArgs): RouteObject[] {
  return routes.map((route) => {
    const updatedRoute: AppRoute = {
      ...route,
      permissions: route.permissions || parentPermissions || [],
    };

    if (route.index) {
      return {
        index: true,
        path: route.path,
        element: <RouteElement pageRoute={updatedRoute} />,
      };
    }

    return {
      path: route.path,
      element: <RouteElement pageRoute={updatedRoute} />,
      children: getRouteChildren({
        routes: route.children || [],
        parentPermissions: updatedRoute.permissions,
      }),
    };
  });
}
